<template>
  <section class="section-comment container" style="padding-top:15px;" data-aos="fade-up" data-aos-once="true" data-aos-duration="100">
    <div class="columns is-gapless">
      <div class="column has-text-centered">
        <div style="padding: 10px 10px 15px;">
          <div class="fb-comments"
            data-href="https://noctorus.studio"
            data-width="100%"
            data-colorscheme="dark"
            data-numposts="5">
          </div>
        </div>
      </div>
      <div class="column has-text-centered">
        <vue-disqus shortname="noctorus" style="padding:10px;padding-bottom:15px;"></vue-disqus>
        <!--<script>
          /**
          *  RECOMMENDED CONFIGURATION VARIABLES: EDIT AND UNCOMMENT THE SECTION BELOW TO INSERT DYNAMIC VALUES FROM YOUR PLATFORM OR CMS.
          *  LEARN WHY DEFINING THESE VARIABLES IS IMPORTANT: https://disqus.com/admin/universalcode/#configuration-variables*/
          /*
          var disqus_config = function () {
          this.page.url = PAGE_URL;  // Replace PAGE_URL with your page's canonical URL variable
          this.page.identifier = PAGE_IDENTIFIER; // Replace PAGE_IDENTIFIER with your page's unique identifier variable
          };
          */
          (function() { // DON'T EDIT BELOW THIS LINE
          var d = document, s = d.createElement('script');
          s.src = 'https://noctorus.disqus.com/embed.js';
          s.setAttribute('data-timestamp', +new Date());
          (d.head || d.body).appendChild(s);
          })();
        </script>
        <noscript>Please enable JavaScript to view the <a href="https://disqus.com/?ref_noscript">comments powered by Disqus.</a>
        </noscript>-->
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: ['error'],
    computed: {
      infos () {
        let infos = []
        for (let i = 0; i < this.error.length; i++) {
          infos.push({
            message: this.error[i]
          })
        }
        return infos
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// SectionComment.vue?6093e772